"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LobbyPage = LobbyPage;
const React = __importStar(require("react"));
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = __importDefault(require("classnames"));
const react_redux_1 = require("react-redux");
const ui_1 = require("@creature-chess/ui");
const PageBackground_1 = require("~/components/PageBackground");
const LobbyPlayerBanner_1 = require("~/components/lobby/LobbyPlayerBanner");
const countdown_1 = require("~/components/ui/countdown");
const networking_1 = require("~/networking");
const plugins_1 = require("~/plugins");
const useStyles_1 = require("~/useStyles");
const padNumberToTwo = (val) => (val < 10 ? `0${val}` : val.toString());
const renderTime = (totalSecondsRemaining) => {
    const minutesRemaining = Math.floor(totalSecondsRemaining / 60);
    const secondsRemaining = Math.ceil(totalSecondsRemaining % 60);
    return React.createElement(React.Fragment, null, `${minutesRemaining}:${padNumberToTwo(secondsRemaining)}`);
};
const useStyles = (0, useStyles_1.createUseThemeStyles)((theme) => ({
    root: {
        position: "relative",
        overflow: "hidden",
        width: "100%",
        height: "100%",
        boxSizing: "border-box",
        containerName: "lobby",
        containerType: "inline-size",
    },
    foreground: {
        position: "absolute",
        inset: 0,
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        gap: "0.5rem",
        padding: "0.5rem",
    },
    scroll: {
        flex: 1,
        minHeight: 0,
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
    card: {
        display: "flex",
        flexDirection: "column",
        gap: "clamp(0.85rem, 4vw, 1.25rem)",
        width: "100%",
        maxWidth: "520px",
        margin: "0 auto",
        padding: "clamp(0.85rem, 4vw, 1.25rem)",
        boxSizing: "border-box",
        background: theme.palette.surface,
        borderRadius: "0.9rem",
    },
    status: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "0.1rem",
        textAlign: "center",
        fontFamily: theme.typography.primary,
        color: theme.palette.light.neutral,
    },
    statusLabel: {
        color: theme.palette.muted,
        fontSize: "0.9rem",
        textTransform: "uppercase",
        letterSpacing: "0.08em",
    },
    statusValue: {
        fontWeight: 700,
        lineHeight: 1,
        fontSize: "clamp(2.4rem, 13vw, 3.25rem)",
        color: theme.palette.accent.neutral,
    },
    statusValueIdle: {
        color: theme.palette.light.neutral,
        fontSize: "clamp(1.6rem, 8vw, 2.25rem)",
    },
    players: {
        "display": "grid",
        "gridTemplateColumns": "repeat(2, minmax(0, 1fr))",
        "gap": "clamp(0.4rem, 2.5vw, 0.7rem)",
        "@media (orientation: landscape)": {
            gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
        },
    },
    footer: {
        width: "100%",
        maxWidth: "520px",
        margin: "0 auto",
    },
    startButton: {
        width: "100%",
    },
}));
function PlayerCountPill({ filled, total }) {
    return (React.createElement(ui_1.AccountPill, { name: `${filled} / ${total}`, icon: React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faUsers }) }));
}
function LobbyPage() {
    const styles = useStyles();
    const lobbyInfo = (0, react_redux_1.useSelector)((state) => state.lobby);
    const lobbyConnection = (0, networking_1.useLobbyConnection)();
    const onStartNow = React.useCallback(() => {
        lobbyConnection === null || lobbyConnection === void 0 ? void 0 : lobbyConnection.sendStartNow();
    }, [lobbyConnection]);
    const playerItems = React.useMemo(() => {
        var _a;
        if (!lobbyInfo) {
            return [];
        }
        const output = [];
        for (let i = 0; i < lobbyInfo.maxPlayers; i++) {
            const player = (_a = lobbyInfo.players[i]) !== null && _a !== void 0 ? _a : null;
            output.push(React.createElement(plugins_1.Region, { key: player ? player.id : i, cls: "lobby-player-slot", id: `lobby.slot.${i}`, ctx: { slotIndex: i, player } },
                React.createElement(LobbyPlayerBanner_1.LobbyPlayerBanner, { player: player })));
        }
        return output;
    }, [lobbyInfo]);
    if (!lobbyInfo) {
        return null;
    }
    const { startTimestamp, maxPlayers } = lobbyInfo;
    const filledCount = lobbyInfo.players.filter(Boolean).length;
    return (React.createElement("div", { className: styles.root },
        React.createElement(PageBackground_1.PageBoardBackground, null),
        React.createElement("div", { className: styles.foreground },
            React.createElement(ui_1.MenuHeaderBar, { brand: React.createElement("img", { src: `${APP_IMAGE_ROOT}/ui/logo.png`, alt: "Creature Chess" }), account: React.createElement(PlayerCountPill, { filled: filledCount, total: maxPlayers }) }),
            React.createElement("div", { className: styles.scroll },
                React.createElement("div", { className: styles.card },
                    React.createElement("div", { className: styles.status }, startTimestamp ? (React.createElement(React.Fragment, null,
                        React.createElement("span", { className: styles.statusLabel }, "Game starting in"),
                        React.createElement("span", { className: styles.statusValue },
                            React.createElement(countdown_1.Countdown, { countdownToSeconds: startTimestamp / 1000, render: renderTime })))) : (React.createElement(React.Fragment, null,
                        React.createElement("span", { className: (0, classnames_1.default)(styles.statusValue, styles.statusValueIdle) }, "Waiting for players"),
                        React.createElement("span", { className: styles.statusLabel }, "The match begins once the lobby fills")))),
                    React.createElement("div", { className: styles.players }, playerItems))),
            React.createElement("div", { className: styles.footer },
                React.createElement(ui_1.MenuPlayButton, { className: styles.startButton, icon: React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faPlay }), title: "Start now", subtitle: "Skip the countdown and begin", onClick: onStartNow })))));
}
